export const FETCH_BILLING_DATES_REQUEST = "FETCH_BILLING_DATES_REQUEST";
export const FETCH_BILLING_DATES_SUCCESS = "FETCH_BILLING_DATES_SUCCESS";
export const FETCH_BILLING_DATES_FAILURE = "FETCH_BILLING_DATES_FAILURE";
export const FETCH_BILLING_DATES_RESET = "FETCH_BILLING_DATES_RESET";
export const fetchBillingDatesRequest = (payload) => ({
    type: FETCH_BILLING_DATES_REQUEST,
    payload,
});
export const fetchBillingDatesSuccess = (payload) => ({
    type: FETCH_BILLING_DATES_SUCCESS,
    payload,
});
export const fetchBillingDatesFailure = (payload) => ({
    type: FETCH_BILLING_DATES_FAILURE,
    payload,
});
export const fetchBillingDatesReset = () => ({
    type: FETCH_BILLING_DATES_RESET,
});
